// Handle popovers like we used to, but using new bootstrap
// http://stackoverflow.com/questions/7703878/how-can-i-hold-twitter-bootstrap-popover-open-until-my-mouse-moves-into-it
import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';

Rover.popoverTemplate = `
    <div class="popover" onmouseover="clearTimeout(Rover.timeoutObj);$(this).mouseleave(function() {$(this).hide();});">
        <div class="arrow"></div>
        <div class="popover-inner">
            <h3 class="popover-title"></h3>
            <div class="popover-content">
                <p></p>
            </div>
        </div>
    </div>`;

Rover.timeoutObj = false;
Rover.stickyPopover = function(selector, option) {
  const $elts = $(selector);
  if (!$elts.length) {
    return;
  }

  const options = $.extend(
    {
      template: Rover.popoverTemplate,
      html: true,
      container: '.js-popover-container',
      trigger: 'manual',
    },
    option
  );

  const onBodyClicked = function(e) {
    const $target = $(e.target);
    $('.popover')
      .not($target.parent())
      .not($target)
      .popover('hide');
  };

  $(selector).each(function() {
    const self = this;
    const $popover = $(this)
      .popover('destroy')
      .popover(options);

    let touched = false;
    let showing = false;
    const showPopover = () => {
      $(self).popover('show');
      showing = true;
    };
    const hidePopover = () => {
      $(self).popover('hide');
      showing = false;
    };

    $popover
      .off('touchstart')
      .on('touchstart', e => {
        // prevents double open/flash
        touched = true;
        setTimeout(() => {
          touched = false;
        }, 150);

        showing ? hidePopover() : showPopover();
      })
      .off('mouseenter')
      .on('mouseenter', e => {
        // prevents double open/flash
        if (touched) return;
        showPopover();
      })
      .off('mouseleave')
      .on('mouseleave', e => {
        Rover.timeoutObj = setTimeout(hidePopover, 50);
      });

    $popover.off('shown.bs.popover').on('shown.bs.popover', () => {
      $('body').on('click', onBodyClicked);

      $(self)
        .off('hide.bs.popover')
        .on('hide.bs.popover', () => {
          $('body').off('click', onBodyClicked);
          $(self).off('hide.bs.popover');
        });
    });
  });
};



// WEBPACK FOOTER //
// ./js/components/sticky_popover.js